import React from 'react';
import FactorTabLayout from '../shared/FactorTabLayout';
import { getTab } from '../config';

/**
 * Ten-year Treasury yields and the bond market.
 *
 * Currently the shared factor layout with nothing extra. Add tab-specific
 * sections as children of FactorTabLayout - they stay isolated to this file.
 */
const TreasuryTab = ({ data, period }) => (
  <FactorTabLayout tab={getTab('treasury')} data={data} period={period} />
);

export default TreasuryTab;
